import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Team', path: '/team' },
      { name: 'Careers', path: '/careers' }
    ],
    investors: [
      { name: 'Data Room', path: '/#investor-access' },
      { name: 'Queens Bench', path: '/properties/queens-bench' },
      { name: 'Golden Triangle', path: '/properties/golden-triangle' },
      { name: 'FAQ', path: '/faq' }
    ],
    legal: [
      { name: 'AML Policy', path: '/aml-policy' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'Terms of Use', path: '/terms-of-use' }
    ]
  };

  return (
    <footer className="relative bg-black border-t border-[#D4AF37]/20">
      {/* Subtle Texture */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: `radial-gradient(circle, #D4AF37 1px, transparent 1px)`,
        backgroundSize: '20px 20px'
      }}></div>

      <div className="relative z-10">
        {/* Upper Footer */}
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            {/* Logo & Newsletter */}
            <div className="lg:col-span-2 space-y-6">
              <img
                src="/images/external/logo-readdy.png"
                alt="ReserveX Capital Ltd"
                className="h-20 md:h-24 w-auto"
              />
              <p className="text-gray-400 text-sm leading-relaxed max-w-md">
                Strategic capital solutions through forward sale agreements for precious metals and critical mineral projects.
              </p>
            </div>

            {/* Company Links */}
            <div>
              <h4 className="text-[#D4AF37] font-semibold mb-4 text-sm uppercase tracking-wider">Company</h4>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-[#C9B037] hover:text-[#F5DEB3] transition-colors text-sm cursor-pointer">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Investors Links */}
            <div>
              <h4 className="text-[#D4AF37] font-semibold mb-4 text-sm uppercase tracking-wider">Investors</h4>
              <ul className="space-y-3">
                {footerLinks.investors.map((link) => (
                  <li key={link.path}>
                    <a href={link.path} className="text-[#C9B037] hover:text-[#F5DEB3] transition-colors text-sm cursor-pointer">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Legal & Contact */}
            <div>
              <h4 className="text-[#D4AF37] font-semibold mb-4 text-sm uppercase tracking-wider">Legal</h4>
              <ul className="space-y-3 mb-6">
                {footerLinks.legal.map((link) => (
                  <li key={link.path}>
                    <Link to={link.path} className="text-[#C9B037] hover:text-[#F5DEB3] transition-colors text-sm cursor-pointer">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>

              <h4 className="text-[#D4AF37] font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h4>
              <div className="space-y-2 text-[#C9B037] text-sm">
                <p>5490 Glen Erin Drive, Unit 7</p>
                <p>Mississauga, ON L5M 5R4</p>
                <a href="mailto:info@reservexcapital.com" className="hover:text-[#F5DEB3] transition-colors block cursor-pointer">
                  info@reservexcapital.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="max-w-7xl mx-auto px-6">
          <div className="h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent"></div>
        </div>

        {/* Lower Footer */}
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <div className="text-white text-sm">
              © {currentYear} ReserveX Capital Ltd. All rights reserved.
            </div>

            {/* Social Media */}
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-[#D4AF37]/50 rounded-lg hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-fill text-[#D4AF37]"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-[#D4AF37]/50 rounded-lg hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-x-fill text-[#D4AF37]"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center border border-[#D4AF37]/50 rounded-lg hover:bg-[#D4AF37]/10 hover:border-[#D4AF37] transition-all duration-300 cursor-pointer">
                <i className="ri-facebook-fill text-[#D4AF37]"></i>
              </a>
            </div>

            {/* Cookies & Powered by */}
            <div className="flex items-center gap-4 text-sm">
              <Link to="/cookies-policy" className="text-white hover:text-[#D4AF37] transition-colors cursor-pointer">
                Cookies Policy
              </Link>
              <span className="text-gray-600">|</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#D4AF37] transition-colors cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
